import React from 'react';
import { ModalToggleState } from '../../models/actionStates';
import { ModalState } from '../../models/ModalState';
import { ProductStepper, ProductStepperProps } from './ProductStepper';

export interface OpenStepperProps extends ProductStepperProps {
  advanceModal: (state: ModalState) => void;
  isMobile: boolean;
}

export const openStepper =
  ({ advanceModal, isMobile, ...props }: OpenStepperProps) =>
  (e?: React.MouseEvent | React.KeyboardEvent) => {
    e?.preventDefault();
    const modalContents = <ProductStepper {...props} />;
    const modalHeightWidth = isMobile ? '100%' : 'auto';
    advanceModal({
      contents: modalContents,
      height: isMobile ? '100vh' : 'auto',
      width: modalHeightWidth,
      maxWidth: isMobile ? '100vw' : '90vw',
      maxHeight: isMobile ? 'unset' : '90vh',
      toggleState: ModalToggleState.Open,
      scrollToTop: isMobile,
      isBaseState: false,
    });
  };
